import React from 'react';
import { Link } from 'react-router-dom';

export const Privacy = () => {
	return (
		<>
			<div className="login-container flex-horizontal">
				<div className="left-img">
					<a href="/">
						<img src={require('assets/img/brand/orbit-logo-dark.png')} />
					</a>
				</div>

				<div className="flex-vertical right-side login flex-center">
					<h1>Privacy Policy</h1>
					<div className="privacy-text">
						<p>orbit.jobs (the &quot;Site&quot;) is owned and operated by Orbit Jobs. Orbit Jobs can be contacted at:</p>

						<p>hello@orbit.jobs (416) 833-3196 240 Waterloo St Unit 101, London, ON N6B 2N4</p>

						<p>Purpose The purpose of this privacy policy (this &quot;Privacy Policy&quot;) is to inform users of our Site of the following:</p>

						<p>The personal data we will collect; Use of collected data; Who has access to the data collected; The rights of Site users; and The Site's cookie policy. This Privacy Policy applies in addition to the terms and conditions of our Site.</p>

						<p>Consent By using our Site users agree that they consent to:</p>

						<p>The conditions set out in this Privacy Policy; and The collection, use, and retention of the data listed in this Privacy Policy. How We Use Personal Data Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.</p>

						<p>Who We Share Personal Data With Employees We may disclose user data to any member of our organization who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy.</p>

						<p>Other Disclosures We will not sell or share your data with other third parties, except in the following cases:</p>

						<p>If the law requires it; If it is required for any legal proceeding; To prove or protect our legal rights; and To buyers or potential buyers of this company in the event that we seek to sell the company. If you follow hyperlinks from our Site to another Site, please note that we are not responsible for and have no control over their privacy policies and practices.</p>

						<p>How Long We Store Personal Data User data will be stored until the purpose the data was collected for has been achieved.</p>

						<p>You will be notified if your data is kept for longer than this period.</p>


						<p> While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical.</p>

						<p>Children We do not knowingly collect or use personal data from children under 13 years of age. If we learn that we have collected personal data from a child under 13 years of age, the personal data will be deleted as soon as possible. If a child under 13 years of age has provided us with personal data their parent or guardian may contact our privacy officer.</p>

						<p>How to Access, Modify, Delete, or Challenge the Data Collected If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to who we disclosed your personal data, or if you would like your data to be deleted or modified in any way, please contact our privacy officer here:</p>

						<p>Dan Hines hello@orbit.jobs 240 Waterloo St Unit 101, London, ON N6B 2N4</p>

						<p>Cookie Policy A cookie is a small file, stored on a user's hard drive by a website. Its purpose is to collect data relating to the user's browsing habits. You can choose to be notified each time a cookie is transmitted. You can also choose to disable cookies entirely in your internet browser, but this may decrease the quality of your user experience.</p>

						<p>We use the following types of cookies on our Site:</p>

						<p>Contact Information If you have any questions, concerns or complaints, you can contact our privacy officer, Dan Hines, at:</p>

						<p>hello@orbit.jobs 240 Waterloo St Unit 101, London, ON N6B 2N4</p>
					</div>

					<Link to="/auth/login">Already Have An Account?</Link>
					<Link to="/auth/register">Don't Have An Account?</Link>
				</div>
			</div>
		</>
	);
};

export default Privacy;
